import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';

import Listarusuario from "./componentes/Listarusuario";
import Editarusuario from "./componentes/Editarusuario";
import Contrasena from "./componentes/Contrasena";
import Crearusuario from './componentes/Crearusuario';

import Listarinfracciones from './componentes/Listarinfracciones';
import Editarinfracciones from './componentes/Editarinfracciones';
import Crearinfraccion from './componentes/Crearinfraccion';

import Multas from './componentes/Multas';
import Crearmultas from './componentes/Crearmultas';
import Listarmultas from "./componentes/Listarmultas";
import Vermulta from "./componentes/Vermulta";
import Pagarmulta from "./componentes/Pagarmulta";

import Solvencias from './componentes/Solvencias';
import Crearsolvencias from './componentes/Crearsolvencias';
import Listarsolvencias from "./componentes/Listarsolvencias";

import Login from "./componentes/login";

import Reportesmultas from './componentes/Reportesmultas';
import Reportessolvencias from './componentes/Reportessolvencias';

import CambiarMiContrasena from "./componentes/CambiarMicontrasena";

import Publico from './componentes/Publico';

import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import RutaPrivada from './componentes/RutaPrivada';

import logoPMT from "./assets/logo_pmt.png";
import logoMuni from "./assets/logo_muni.png";

function Inicio() {
  return (
    <div className="text-center mt-5">
      <h1>Bienvenido al sistema PMT CHIANTLA</h1>
      <p>Sistema de control administrativo</p>
    </div>
  );
}

function App() {
  const usuario = JSON.parse(localStorage.getItem("usuario"));

  return (
    <Router>

      
        {usuario && (
    <div className="container mt-3">

        <div className="encabezado-sistema mb-3">
            <img src={logoMuni} alt="Municipalidad" className="logo-header" />

            <div className="text-center">
                <h3 className="mb-0">Sistema de Información PMT Chiantla</h3>
                <small>Policía Municipal de Tránsito</small>
            </div>

            <img src={logoPMT} alt="PMT" className="logo-header-pmt" />
        </div>

        <div className="d-flex justify-content-end mb-3">

            <span className="me-2 fw-bold">
              {usuario.usuario}
            </span>

            <Link
              to="/micuenta/contrasena"
              className="text-primary text-decoration-none me-3"
            >
              Cambiar contraseña
            </Link>

            <a
              href="/login"
              className="text-danger text-decoration-none"
              onClick={(e) => {
                e.preventDefault();
                localStorage.removeItem("usuario");
                window.location.href = "/";
              }}
            >
              (Cerrar sesión)
            </a>

          </div>

          <div className="row g-3 justify-content-center">

            <div className="col-md-2">
              <Link to="/inicio" className="btn btn-dark w-100 p-4">
                INICIO
              </Link>
            </div>

            {Number(usuario?.rol) === 1 && (
              <div className="col-md-2">
                <Link to="/usuarios" className="btn btn-success w-100 p-4">
                  USUARIOS
                </Link>
              </div>
            )}

            {[1, 2, 3].includes(Number(usuario?.rol)) && (
              <div className="col-md-2">
                <Link to="/infracciones" className="btn btn-danger w-100 p-4">
                  INFRACCIONES
                </Link>
              </div>
            )}

            {[1, 2, 3].includes(Number(usuario?.rol)) && (
              <div className="col-md-2">
                <Link to="/multas" className="btn btn-warning w-100 p-4">
                  MULTAS
                </Link>
              </div>
            )}

            {[1, 2].includes(Number(usuario?.rol)) && (
              <div className="col-md-2">
                <Link to="/solvencias" className="btn btn-primary w-100 p-4">
                  SOLVENCIAS
                </Link>
              </div>
            )}

          </div>
        </div>
      )}

      <div className="container mt-4">

        <Routes>

          <Route path="/" element={<Publico />} />

          <Route
            path="/login"
            element={usuario ? <Navigate to="/inicio" /> : <Login />}
          />

          <Route
            path="/inicio"
            element={
              <RutaPrivada>
                <Inicio />
              </RutaPrivada>
            }
          />

          <Route
            path="/usuarios"
            element={
              <RutaPrivada rolesPermitidos={[1, 2]}>
                <Listarusuario />
              </RutaPrivada>
            }
          />

          <Route
            path="/usuarios/contrasena/:id"
            element={
              <RutaPrivada rolesPermitidos={[1]}>
                <Contrasena />
              </RutaPrivada>
            }
          />

          <Route
            path="/usuarios/editarusuario/:id"
            element={
              <RutaPrivada rolesPermitidos={[1]}>
                <Editarusuario />
              </RutaPrivada>
            }
          />

          <Route
            path="/usuarios/crear"
            element={
              <RutaPrivada rolesPermitidos={[1, 2]}>
                <Crearusuario />
              </RutaPrivada>
            }
          />

          <Route
            path="/micuenta/contrasena"
            element={
              <RutaPrivada rolesPermitidos={[1, 2, 3]}>
                <CambiarMiContrasena />
              </RutaPrivada>
            }
          />

          <Route
            path="/infracciones"
            element={
              <RutaPrivada rolesPermitidos={[1, 2, 3]}>
                <Listarinfracciones />
              </RutaPrivada>
            }
          />

          <Route
            path="/infracciones/editarinfracciones/:id"
            element={
              <RutaPrivada rolesPermitidos={[1, 2]}>
                <Editarinfracciones />
              </RutaPrivada>
            }
          />

          <Route
            path="/infracciones/crearinfraccion"
            element={
              <RutaPrivada rolesPermitidos={[1, 2]}>
                <Crearinfraccion />
              </RutaPrivada>
            }
          />

          <Route
            path="/multas"
            element={
              <RutaPrivada rolesPermitidos={[1, 2, 3]}>
                <Multas />
              </RutaPrivada>
            }
          />

          <Route
            path="/Crearmultas"
            element={
              <RutaPrivada rolesPermitidos={[1, 3]}>
                <Crearmultas />
              </RutaPrivada>
            }
          />

          <Route
            path="/listarmultas"
            element={
              <RutaPrivada rolesPermitidos={[1, 2, 3]}>
                <Listarmultas />
              </RutaPrivada>
            }
          />

          <Route
            path="/vermulta/:idmulta"
            element={
              <RutaPrivada rolesPermitidos={[1, 2, 3]}>
                <Vermulta />
              </RutaPrivada>
            }
          />

          <Route
            path="/pagarmulta/:id"
            element={
              <RutaPrivada rolesPermitidos={[1, 2]}>
                <Pagarmulta />
              </RutaPrivada>
            }
          />

          <Route
            path="/reportesmultas"
            element={
              <RutaPrivada rolesPermitidos={[1, 2]}>
                <Reportesmultas />
              </RutaPrivada>
            }
          />

          <Route
            path="/solvencias"
            element={
              <RutaPrivada rolesPermitidos={[1, 2]}>
                <Solvencias />
              </RutaPrivada>
            }
          />

          <Route
            path="/crearsolvencias"
            element={
              <RutaPrivada rolesPermitidos={[1, 2, 3]}>
                <Crearsolvencias />
              </RutaPrivada>
            }
          />

          <Route
            path="/listarsolvencias"
            element={
              <RutaPrivada rolesPermitidos={[1, 2]}>
                <Listarsolvencias />
              </RutaPrivada>
            }
          />

          <Route
            path="/reportessolvencias"
            element={
              <RutaPrivada rolesPermitidos={[1, 2]}>
                <Reportessolvencias />
              </RutaPrivada>
            }
          />

        </Routes>

      </div>

    </Router>
  );
}

export default App;